import { TicketCheckin, TicketCheckinType } from 'types/domain';

const TicketScannedBy = ({ checkin }: { checkin: TicketCheckin }) =>
    checkin?.user ? (
        <div className={'flex flex-col'}>
            <p className={'text-sm font-medium text-gray-800'}>Checked in by:</p>
            <p
                className={'text-sm text-gray-600'}
            >{`${checkin.user.first_name} ${checkin.user.last_name} (${checkin.user.email})`}</p>
            <p className={'text-sm text-gray-600'}>{`Source: ${
                checkin.source
            } (${typeToDisplayString(checkin.type)})`}</p>
        </div>
    ) : null;

const typeToDisplayString = (type: TicketCheckinType): string => {
    switch (type) {
        case 'purchase_auto':
            return 'at time of purchase';
        case 'manual':
            return 'checked in manually';
        case 'scan':
            return 'scanned';
    }
};

export { TicketScannedBy };
